import React, { useState } from 'react'
import { useIntl } from 'react-intl'

import PingPongButton from '../../buttons-by-step/PingPongButton'
import { PingPongButtonTypeEnum } from '../../utils/ping-pong-button-type.enum.ts'
import {
  ClientRequestPaymentStatusEnum,
  Payment_Type,
} from '../../../../../../lib/graphql'
import PaymentModeModal from '../../../../../templates/client-request-cart/cart/components/PaymentModeModal/PaymentModeModal'

const UserPaymentButton = ({
  payment,
  handlePayment,
  clientRequestId,
  houseId,
  serviceProviderId,
}: {
  payment: {
    paymentStatus: ClientRequestPaymentStatusEnum
    paymentAmount: number
    paymentType: Payment_Type
  }
  handlePayment?: () => void
  clientRequestId: string
  houseId?: string | null
  serviceProviderId?: string | null
}) => {
  const intl = useIntl()
  const [isPaymentModeModalOpen, setIsPaymentModeModalOpen] =
    useState<boolean>(false)

  let paymentToDoLabel = ''
  let paymentDoneLabel = ''

  switch (payment.paymentType) {
    case Payment_Type.DEPOSIT:
      paymentToDoLabel = intl.formatMessage({
        id: 'ui.UserPaymentButton.payDeposit',
        defaultMessage: "Régler l'acompte",
      })
      paymentDoneLabel = intl.formatMessage({
        id: 'ui.UserPaymentButton.depositPaid',
        defaultMessage: 'Acompte réglé',
      })
      break
    case Payment_Type.BALANCE:
      paymentToDoLabel = intl.formatMessage({
        id: 'ui.UserPaymentButton.payBalance',
        defaultMessage: 'Régler le solde',
      })
      paymentDoneLabel =
        payment.paymentAmount >= 0
          ? intl.formatMessage({
              id: 'ui.UserPaymentButton.balancePaid',
              defaultMessage: 'Solde réglé',
            })
          : intl.formatMessage({
              id: 'ui.UserPaymentButton.balanceRefunded',
              defaultMessage: 'Solde remboursé',
            })
      break
    case Payment_Type.BALANCE_POST_FINAL:
      paymentToDoLabel = intl.formatMessage({
        id: 'ui.UserPaymentButton.payBalancePostFinal',
        defaultMessage: 'Régler le solde post-séjour',
      })
      paymentDoneLabel =
        payment.paymentAmount >= 0
          ? intl.formatMessage({
              id: 'ui.UserPaymentButton.balancePaidPostFinal',
              defaultMessage: 'Solde post-séjour réglé',
            })
          : intl.formatMessage({
              id: 'ui.UserPaymentButton.balancePostFinalRefunded',
              defaultMessage: 'Solde post-séjour remboursé',
            })
      break
  }

  switch (payment.paymentStatus) {
    case ClientRequestPaymentStatusEnum.TO_DO:
      return (
        <>
          {payment.paymentAmount > 0 ? (
            <>
              <PingPongButton
                type={PingPongButtonTypeEnum.PAYMENT}
                label={paymentToDoLabel}
                onClick={() => setIsPaymentModeModalOpen(true)}
                dataTestId='pay-button'
              />
              <PaymentModeModal
                paymentAmount={payment.paymentAmount}
                isPaymentModeModalOpen={isPaymentModeModalOpen}
                setIsPaymentModeModalOpen={setIsPaymentModeModalOpen}
                handlePayment={handlePayment}
                paymentType={payment.paymentType}
                clientRequestId={clientRequestId}
                houseId={houseId}
                serviceProviderId={serviceProviderId}
              />
            </>
          ) : payment.paymentAmount === 0 ? (
            <PingPongButton
              label={intl.formatMessage({
                id: 'ui.UserPaymentButton.nextStepWithoutBalance',
                defaultMessage:
                  "Passer à l'étape suivante sans payer (solde a 0€)",
              })}
              type={PingPongButtonTypeEnum.PAYMENT}
            />
          ) : (
            <PingPongButton
              label={intl.formatMessage({
                id: 'ui.UserPaymentButton.waitingForRefund',
                defaultMessage: 'En attente de remboursement',
              })}
              type={PingPongButtonTypeEnum.WAITING}
            />
          )}
        </>
      )
    case ClientRequestPaymentStatusEnum.PENDING:
      return (
        <PingPongButton
          label={intl.formatMessage({
            id: 'ui.UserPaymentButton.sampleInProgress',
            defaultMessage: 'Prélèvement en cours de validation',
          })}
          type={PingPongButtonTypeEnum.WAITING}
        />
      )

    case ClientRequestPaymentStatusEnum.DONE:
      return (
        <PingPongButton
          label={paymentDoneLabel}
          type={PingPongButtonTypeEnum.PAYMENT_DONE}
          dataTestId='payment-done-button'
        />
      )
  }
}

export default UserPaymentButton
